import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { AutenticationService } from '../../../autentication/autentication.service';
import { ThemeService } from '../../../shared/theme-service/theme.service';
import { RatePackageEventType } from '../rate-package.event.type';
import { FormatPricePipe } from '../../../shared/format-price.pipe';
import { EventTypes } from '../../../shared/EventTypes';
import { Auth } from '../../../autentication/Auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Pacote } from '../models/pacote.model';
import * as printJS from 'print-js';
import { RatePackageService } from '../rate-package.service';
import * as moment from 'moment';

@Component({
	selector: 'app-package-confirmation',
	templateUrl: './package-confirmation.component.html',
	styleUrls: ['./package-confirmation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PackageConfirmationComponent implements OnInit, OnDestroy {

	@Input() submited = false;
	@Input() hirePackage: Pacote;
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	private view = '[data-component="package-confirmation"]';
	private confirmList: Array<ListItem> = [];
	private sendConfirmedPackage = false;

	public form: FormGroup;
	public formAdhesion: FormGroup;
	public contractChecked = false;
	public active = false;
	public isAttendant = false;
	public activeBackButton = false;
	public disabled = true;
	public showStepButtons = false;

	constructor(
		private autenticationService: AutenticationService,
		private themeService: ThemeService,
		private formBuilder: FormBuilder,
		private ratePackageService: RatePackageService) {
	}

	ngOnInit() {
		this.formAdhesion = this.formBuilder.group({
			'viewContract': [null,  Validators.required]
		});

		this.isAttendant = this.themeService.isAttendant();
		AppEventDispatcher.listen(RatePackageEventType.STEPS.CONFIRM, data => {
			if (data.show) {
				this.show();
			}
		});


		AppEventDispatcher.listen(RatePackageEventType.SEND.DATA_CONFIRM, () => {
			this.send();
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(RatePackageEventType.STEPS.CONFIRM);
		AppEventDispatcher.removeListener(RatePackageEventType.SEND.DATA_CONFIRM);
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
		this.setForm.emit(this.form);

		if (this.sendConfirmedPackage) {
			this.send();
		}
	}

	show() {
		this.active = true;
		this.buildConfirmList();
		this.preload(false);
	}

	buildConfirmList() {
		const FP = new FormatPricePipe();
		this.confirmList = [];
		this.confirmList.push(new ListItem('Pacote:', this.hirePackage.nmPacote));
		this.confirmList.push(new ListItem('Valor do pacote:', FP.transform(this.hirePackage.vlrPacote, false) + '/ mês'));
	}

	send() {
		this.submited = true;
		if (this.form.valid) {
			this.readySend();
		}
		this.submited = false;
	}

	addAuthToken() {
		Auth.passToken = this.form.value.token ? this.form.value.token : '';
		Auth.assinaturaEletronica = this.form.value.eletronicSignature ? this.form.value.eletronicSignature : '';
	}

	readySend() {
		const date = moment(this.hirePackage.dtVigencia).format('YYYY-MM-DD');

		this.addAuthToken();

		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.ratePackageService.hirePackage(this.hirePackage.codPacote, date).subscribe(o => {
					if (o.Sucesso) {
						this.active = false;
						this.preload(true);
						AppEventDispatcher.dispatch(RatePackageEventType.STEPS.RESULT, { show: true, data: o.Retorno.CodSituacao }); // 1 Pendente 2 Autorizado
					}
			}, error => {
				this.handleError(error);
			});
			}
		}, error => {
			this.handleError(error);
		});
	}

	handleError(error) {
		this.preload(false);
		this.disabled = false;
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		AppEventDispatcher.dispatch(RatePackageEventType.ERROR, { step: RatePackageEventType.SEND.DATA_CONFIRM });
	}


	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, { element: '[data-component="rate-package"] .content', show: active, delay: delay });
	}

	printPdf() {
		this.preload(true);
		const date = moment(this.hirePackage.dtVigencia).format('YYYY-MM-DD');
		this.ratePackageService.getTerm(this.hirePackage.codPacote, date).subscribe(data => {
			if (data.Sucesso) {
				printJS({ printable: data.Retorno, type: 'pdf', base64: true });
			}
			this.preload(false);
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Ocorreu um erro, tente novamente mais tarde.' });
			this.preload(false);
		});

	}

	changeTerms(checked: boolean) {
		this.contractChecked = checked;
		this.disabled = !checked;
	}

	checkNextButton(): boolean {
		return this.disabled || this.form.invalid;
	}

	public getMessageConfirmedPackage(message: boolean) {
		this.sendConfirmedPackage = message;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rate-package/package-confirmation/package-confirmation.component.ts